import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { useStrapiPost } from '../hooks/useStrapiPost';

export default function BlogPost() {
  const { slug } = useParams();
  const { post, loading, error } = useStrapiPost(slug);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center px-6">
        <p className="text-gray-500">Loading article…</p>
      </div>
    );
  }

  if (error || !post) {
    return (
      <div className="min-h-screen flex items-center justify-center px-6">
        <div className="space-y-4 text-center">
          <p className="text-lg font-semibold text-charcoal">Article not available</p>
          <p className="text-sm text-gray-500">
            Something went wrong while fetching that post. Head back to the blog list to continue browsing.
          </p>
          <Link to="/blog" className="text-primary font-semibold">
            View blog
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white min-h-screen py-20 px-6">
      <div className="max-w-4xl mx-auto space-y-8">
        {post.heroImage && (
          <img src={post.heroImage} alt={post.title} className="h-64 w-full rounded-3xl object-cover" />
        )}
        <div className="space-y-2">
          <p className="text-xs uppercase tracking-[0.6em] text-gray-500">{post.publishedAt}</p>
          <h1 className="text-4xl font-bold text-charcoal">{post.title}</h1>
          <p className="text-gray-600 leading-relaxed">{post.excerpt}</p>
        </div>
        <article className="prose max-w-none text-gray-700">
          <div dangerouslySetInnerHTML={{ __html: post.body || '<p>No content yet.</p>' }} />
        </article>
        <div className="flex items-center justify-between rounded-3xl border border-primary/20 bg-primary/5 p-6">
          <div>
            <p className="text-sm uppercase tracking-[0.4em] text-gray-500">Need help?</p>
            <p className="text-lg font-semibold text-charcoal">Book a strategy assessment</p>
            <p className="text-gray-600 text-sm">We will prep a defendable plan with your CPA.</p>
          </div>
          <Link to="/free-assessment" className="rounded-full bg-primary px-6 py-3 text-sm font-semibold text-white">
            Launch assessment
          </Link>
        </div>
      </div>
    </div>
  );
}
